import { PaymentMethodFormData } from "@/pages/Wallet/components/paymentMethodModal/type";

export const getInitialFormData = (): PaymentMethodFormData => ({
  type: "bank" as const,
  label: "",
  isDefault: true,
  details: {
    accountHolderName: "",
    bankName: "",
    accountNumber: "",
    branchName: "",
    routingCode: "",
    country: "",
    bankAddress: "",
    contactNumber: "",
  },
});

export const getRoutingLabel = (country: string): string => {
  switch (country) {
    case "IN":
      return "IFSC Code";
    case "US":
      return "Routing Number";
    case "UK":
      return "Sort Code";
    default:
      return "Routing Code";
  }
};

export const getRoutingPlaceholder = (country: string): string => {
  switch (country) {
    case "IN":
      return "e.g., HDFC0000123";
    case "US":
      return "e.g., 021000021";
    case "UK":
      return "e.g., 20-00-00";
    default:
      return "Enter routing code";
  }
};

export const getRoutingMaxLength = (country: string): number => {
  switch (country) {
    case "IN":
      return 11;
    case "US":
      return 9;
    case "UK":
      return 8;
    default:
      return 20;
  }
};

export const validateAccountNumber = (
  accountNumber: string,
  country: string
): { isValid: boolean; message?: string } => {
  if (!accountNumber.trim()) {
    return { isValid: false, message: "Please enter account number" };
  }

  switch (country) {
    case "IN":
      if (accountNumber.length < 9 || accountNumber.length > 18) {
        return {
          isValid: false,
          message: "Indian account numbers should be 9-18 digits",
        };
      }
      break;
    case "US":
      if (accountNumber.length < 8 || accountNumber.length > 17) {
        return {
          isValid: false,
          message: "US account numbers should be 8-17 digits",
        };
      }
      break;
    case "UK":
      if (accountNumber.length < 6 || accountNumber.length > 8) {
        return {
          isValid: false,
          message: "UK account numbers should be 6-8 digits",
        };
      }
      break;
  }

  return { isValid: true };
};

export const validateUSRoutingNumber = (
  routingNumber: string
): { isValid: boolean; message?: string } => {
  if (routingNumber.length !== 9) {
    return { isValid: false, message: "US routing number must be 9 digits" };
  }

  // Basic ABA routing number checksum validation
  const digits = routingNumber.split("").map(Number);
  const checksum =
    (3 * (digits[0] + digits[3] + digits[6]) +
      7 * (digits[1] + digits[4] + digits[7]) +
      (digits[2] + digits[5] + digits[8])) %
    10;

  if (checksum !== 0) {
    return { isValid: false, message: "Invalid US routing number" };
  }

  return { isValid: true };
};

export const validateIFSCCode = (
  ifscCode: string
): { isValid: boolean; message?: string } => {
  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  if (!ifscRegex.test(ifscCode)) {
    return {
      isValid: false,
      message: "Invalid IFSC code format (e.g., HDFC0000123)",
    };
  }
  return { isValid: true };
};
